import { Injectable } from '@angular/core';
import { CacheHouse } from './cachehouse.interface';

@Injectable({ providedIn: 'root' })
export class CacheHouseLocalStorage implements CacheHouse {
  store: any;
  constructor() {
    if (!window.localStorage) {
      console.log(`Your browser doesn't support localStorage`);
      return;
    }
    this.store = window.localStorage;
  }

  setItem(key: string, value: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const db = this.store;
      db.setItem(key, JSON.stringify(value));
      resolve(true);
    });
  }

  getItem(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const db = this.store;
      const item = db.getItem(key);
      resolve(item);
    });
  }

  removeItem(key: string) {
    const db = this.store;
    const result = db.removeItem(key);
    return true;
  }

  getAll(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve([]);
    });
  }
}
